// extracted by mini-css-extract-plugin
export default {"navigation-container":"pct1V_navigation-container","header-container":"Z_UFb_header-container","navi-icon":"XQ7CO_navi-icon","header-title":"ARZqo_header-title"};